import { render, staticRenderFns } from "./activeLimitDefauleJump.vue?vue&type=template&id=2ab1c712&scoped=true"
import script from "./activeLimitDefauleJump.vue?vue&type=script&lang=js"
export * from "./activeLimitDefauleJump.vue?vue&type=script&lang=js"
import style0 from "./activeLimitDefauleJump.vue?vue&type=style&index=0&id=2ab1c712&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab1c712",
  null
  
)

export default component.exports